import { withInstall } from '@ll-plus/utils'

import ColorPresetPicker from './src/color-preset-picker.vue'

export const LlColorPresetPicker = withInstall(ColorPresetPicker)
export default LlColorPresetPicker
export * from './src/color-preset-picker'

declare module 'vue' {
  export interface GlobalComponents {
    LlColorPresetPicker: typeof ColorPresetPicker
  }
}
